import {
  type EdgeId,
  type EdgeRecord,
  type NodeId,
  type PathLookupEdgeData,
  isPathLookupEdgeData,
} from '@ipfabric/utils';
import { propOf } from '@ipfabric/utils/fp/prop';
import type { GraphData } from '../model/GraphData';

export const getPacketPath = (
  packetEdge: PathLookupEdgeData,
  edges: EdgeRecord,
  graphData: GraphData,
): {
  edgeIds: Set<EdgeId>;
  nodeIds: Set<NodeId>;
} => {
  const visitedEdges = new Set<EdgeId>([]);
  const visitedNodes = new Set<NodeId>([]);

  const visitPacketChain = (
    chainProp: 'prevEdgeIds' | 'nextEdgeIds',
    fromPacket: PathLookupEdgeData,
  ): void => {
    visitedEdges.add(fromPacket.id);
    visitedNodes.add(fromPacket.source);
    visitedNodes.add(fromPacket.target);

    // biome-ignore lint/complexity/noForEach: reasonable for readability, would need extensive refactor
    fromPacket[chainProp]
      // Filter out visited edges and terminated packet edge IDs
      .filter(
        (edgeId) =>
          !visitedEdges.has(edgeId) && graphData.edges[edgeId] !== undefined,
      )
      .map(propOf(edges))
      .filter(isPathLookupEdgeData)
      .forEach((followingPacket) => {
        visitPacketChain(chainProp, followingPacket);
      });
  };

  visitPacketChain('prevEdgeIds', packetEdge);
  visitPacketChain('nextEdgeIds', packetEdge);

  return {
    nodeIds: visitedNodes,
    edgeIds: visitedEdges,
  };
};
